import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { map } from 'rxjs/operators';
import { User } from '../models';

@Injectable({ providedIn: 'root' })
export class UserService {

  private path = '/users';

  constructor(private http: AlloxApiService) { }

  public fetch(id: string) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new User(obj))
    );
  }

  public post(item: User) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: User) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public resetPassword(item: User) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id + '/password/reset', json);
  }
}
